import React from 'react';

/**
 * Visual frame for the GRID container: draws cols×rows cells with a gap.
 * Blocks dropped into the grid are independent siblings positioned over these
 * cells, so this component only paints the cell guides / backgrounds.
 *  - In the builder we show dashed cell outlines so the designer sees the grid.
 *  - On the public page outlines default off (just spacing), with optional
 *    per-cell background + border + radius.
 */
const GridBlock: React.FC<{
  cols: number;
  rows: number;
  gap: number;
  /** show the dashed guide outlines (builder = true, public = props-driven) */
  guides?: boolean;
  cellBg?: string;
  cellBorderColor?: string;
  cellRadius?: number;
}> = ({ cols, rows, gap, guides, cellBg, cellBorderColor, cellRadius }) => {
  const count = Math.max(1, cols) * Math.max(1, rows);
  return (
    <div
      style={{
        width: '100%', height: '100%', boxSizing: 'border-box',
        display: 'grid',
        gridTemplateColumns: `repeat(${Math.max(1, cols)}, 1fr)`,
        gridTemplateRows: `repeat(${Math.max(1, rows)}, 1fr)`,
        gap,
        pointerEvents: 'none',
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          style={{
            background: cellBg || 'transparent',
            border: guides
              ? '1px dashed #c4b5fd'
              : (cellBorderColor ? `1px solid ${cellBorderColor}` : 'none'),
            borderRadius: cellRadius ? `${cellRadius}px` : undefined,
          }}
        />
      ))}
    </div>
  );
};

export default GridBlock;
